export default __webpack_public_path__ + "static/media/logo.ab9aaf8d.png";